/** ISO 3166-1 alpha-2 → flag emoji (regional indicators). */
export function countryCodeToFlagEmoji(countryCode) {
  const code = String(countryCode ?? "")
    .trim()
    .toUpperCase();
  if (!/^[A-Z]{2}$/.test(code)) {
    return "🏳️";
  }
  const points = [...code].map((char) => 0x1f1e6 - 65 + char.charCodeAt(0));
  return String.fromCodePoint(...points);
}

/** Reliable PNG flags (emoji flags are often missing on Windows). */
export function countryFlagImageUrl(countryCode, width = 40) {
  const code = String(countryCode ?? "")
    .trim()
    .toLowerCase();
  if (!/^[a-z]{2}$/.test(code)) {
    return "";
  }
  return `https://flagcdn.com/w${width}/${code}.png`;
}
